




































import { Component } from 'vue-property-decorator';
import Alert from '@/components/Shared/Alert.vue';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import { AuthModule } from '@/store/Auth/AuthModule';
import WelcomeWidget from '@/components/Dashboard/Widgets/WelcomeWidget.vue';
import HolidaysWidget from '@/components/Dashboard/Widgets/HolidaysWidget.vue';
import AccountsChart from '@/components/Dashboard/Charts/AccountsChart.vue';
import AccountsByProductChart from '@/components/Dashboard/Charts/AccountsByProductChart.vue';
import ProductMigrationsWidget from '@/components/Dashboard/Widgets/ProductMigrationsWidget.vue';
import BalancesWidget from '@/components/Dashboard/Widgets/BalancesWidget.vue';
import KnowledgeBaseWidget from '@/components/Dashboard/Widgets/KnowledgeBaseWidget.vue';
import LiabilitiesWidget from '@/components/Dashboard/Widgets/LiabilitiesWidget.vue';
import PermissionUtils from '@/lib/permissionUtils';
import PermissionType from '@/models/Settings/Roles/PermissionType';
import FeatureToggleCode from "@/models/Settings/Institutions/FeatureToggleCode";

@Component({ name: 'Dashboard', components: {
    Alert,
    SaascadaVue,
    WelcomeWidget,
    HolidaysWidget,
    AccountsChart,
    AccountsByProductChart,
    ProductMigrationsWidget,
    BalancesWidget,
    KnowledgeBaseWidget,
    LiabilitiesWidget
}, metaInfo: { title: 'Dashboard' } })
export default class extends SaascadaVue {

    PermissionUtils = PermissionUtils;
    FeatureToggleCode = FeatureToggleCode;

    get isWidgetDemoEnabled() {
        return PermissionUtils.isFeatureToggleEnabled(FeatureToggleCode.DashboardWidgetDemo);
    }

    get isCashbackEnabled() {
        return AuthModule.me.institution.config.showRewardPayments;
    }

}
